export default __webpack_public_path__ + "static/media/moon.ed34e3cc.png";